import DashboardLayout from '../layouts/DashboardLayout'

export const productsManagement = {
  path: '',
  component: DashboardLayout,
  name: 'Products',
  redirect: '/products',
  children: [
    {
      path: '/products',
      name: 'Product',
      component: () => import (/* webpackChunkName: "product" */'../pages/product-management/index.vue'),
      meta: {
        roles: 'all',
        requiresAuth: true,
        breadcrumb: [{
          title: 'Quản lý sản phẩm',
        }],
        title: 'OMS Product List',
      },
    },
    {
      path: '/products/create',
      name: 'CreateProduct',
      component: () => import (/* webpackChunkName: "product" */'../pages/product-management/detail.vue'),
      meta: {
        roles: 'all',
        requiresAuth: true,
        breadcrumb: [{
          title: '',
        }],
        title: 'OMS New Product',
      },
    },
    {
      path: '/products/:id',
      name: 'UpdateProduct',
      component: () => import (/* webpackChunkName: "product" */'../pages/product-management/detail.vue'),
      meta: {
        roles: 'all',
        requiresAuth: true,
        breadcrumb: [{
          title: '',
        }]
      },
    },
    {
      path: '/products/:id/sku/:sku_id',
      name: 'SkuDetail',
      component: () => import (/* webpackChunkName: "product" */'../pages/product-management/sku-detail.vue'),
      meta: {
        roles: 'all',
        requiresAuth: true,
        breadcrumb: [{
          title: '',
        }]
      },
    },
    {
      path: '/products/:id/sku-combo/:sku_id',
      name: 'SkuComboDetail',
      component: () => import (/* webpackChunkName: "product" */'../pages/product-management/sku-combo-detail.vue'),
      meta: {
        roles: 'all',
        requiresAuth: true,
        breadcrumb: [{
          title: '',
        }]
      },
    },
  ],
}
